var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.show,"width":"50%","persistent":""}},[_c('v-card',[_c('v-card-title',[_vm._v(" Loading... ")]),_c('v-card-text',[_c('v-progress-linear',{attrs:{"value":_vm.progress,"height":25}},[_vm._v(" "+_vm._s(_vm.progress)+"% ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }